var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label
      ? _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
    _vm._v(" "),
    _vm.required
      ? _c("span", { staticClass: "text-danger" }, [_vm._v(" *")])
      : _vm._e(),
    _vm._v(" "),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.vModel,
          expression: "vModel",
        },
      ],
      staticClass: "form-control",
      attrs: {
        id: _vm.name,
        name: _vm.name,
        rows: _vm.rows,
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
      },
      domProps: { value: _vm.vModel },
      on: {
        input: [
          function ($event) {
            if ($event.target.composing) return
            _vm.vModel = $event.target.value
          },
          _vm.handleInput,
        ],
        blur: _vm.validateValue,
      },
    }),
    _vm._v(" "),
    _vm.validationError || (_vm.errors && _vm.errors[_vm.name])
      ? _c("small", { staticClass: "form-text text-danger" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.validationError || _vm.errors[_vm.name][0]) +
              "\n  "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }